import $ from "jquery";

$(document).on("click", ".garageCell__image", function (e) {
	e.preventDefault();

	const garage_id = $(this).attr("data-id");
	const modal_url = $(this).attr("data-url");
	const modal_id = "#modal-" + garage_id;
	const $modal = $(modal_id);
	if ($modal.length) {
		$('footer.sectionFooter').append($modal)

		$modal.toggleClass("open");
		return;
	}

	$.ajax({
		url: modal_url,
		data: {
			garage_id: garage_id
		},
		dataType: "json",
		success: function (data) {
			$("footer.sectionFooter").append(data);
		}
	});
});

$(document).on("click", ".close-button-modal", function (e) {
	e.preventDefault();

	$(this).closest(".garageModal").removeClass("open");

	$("footer.sectionFooter .garageModal:not(:last-child):not(:nth-last-child(2)):not(:nth-last-child(3))").remove();
});
